<template>
  <div>
    <b-collapse v-model="show">
      <b-card title="通信経路新規作成">
        <!-- no -->
        <b-form-group
          label="番号"
          label-for="no"
          label-cols=3
        >
          <b-form-input
            v-model="communicationPath.no"
            id="no"
          ></b-form-input>
        </b-form-group>
        <!-- design sender -->
        <b-form-group
          label="設計用送信元"
          label-for="design_sender"
          label-cols=3
        >
          <b-form-input
            v-model="communicationPath.design_sender"
            id="design_sender"
          ></b-form-input>
        </b-form-group>
        <!-- design destination -->
        <b-form-group
          label="設計用送信先"
          label-for="design_destination"
          label-cols=3
        >
          <b-form-input
            v-model="communicationPath.design_destination"
            id="design_destination"
          ></b-form-input>
        </b-form-group>
        <!-- physical connection -->
        <b-form-group
          label="物理接続"
          label-for="physical_connection"
          label-cols=3
        >
          <b-form-select
            v-model="communicationPath.physical_connection"
            :options="[true, false]"
          ></b-form-select>
        </b-form-group>
        <!-- communication_path_list -->
        <b-form-group
          label="宛先分割"
          label-cols=3
        >
          <b-table
            :fields="fields"
            :items="communicationPath.communication_path_list"
            bordered
          >
            <template v-slot:cell(delete)="data">
              <b-button @click="deleteCommunicationPath(data)">削除</b-button>
            </template>
          </b-table>
          <b-row align-h="end">
            <b-button
              variant="outline-info"
              small
              pill
              @click="showAddCommunicationPath = !showAddCommunicationPath"
            >+</b-button>
          </b-row>
          <b-row align-h="center">
            <b-collapse v-model="showAddCommunicationPath">
              <b-card>
                <!-- sa -->
                <b-form-group
                  label="sa"
                  label-for="each_sa"
                  label-cols=3
                >
                  <b-form-input
                    id="each_sa"
                    v-model="splitDestination.sa"
                  ></b-form-input>
                </b-form-group>
                <!-- sd -->
                <b-form-group
                  label="sd"
                  label-for="each_sd"
                  label-cols=3
                >
                  <b-form-input
                    id="each_sd"
                    v-model="splitDestination.sr"
                  ></b-form-input>
                </b-form-group>
                <!-- da -->
                <b-form-group
                  label="da"
                  label-for="each_da"
                  label-cols=3
                >
                  <b-form-input
                    id="each_da"
                    v-model="splitDestination.da"
                  ></b-form-input>
                </b-form-group>
                <!-- dr -->
                <b-form-group
                  label="dr"
                  label-for="each_dr"
                  label-cols=3
                >
                  <b-form-input
                    id="each_dr"
                    v-model="splitDestination.dr"
                  ></b-form-input>
                </b-form-group>
                <!-- protocol -->
                <b-form-group
                  label="protocol"
                  label-for="each_protocol"
                  label-cols=3
                >
                  <b-form-select
                    id="each_protocol"
                    v-model="splitDestination.protocol"
                    :options="protocols"
                  ></b-form-select>
                </b-form-group>
                <b-button
                  variant="outline-info"
                  @click="addCommunicationPath"
                >追加</b-button>
              </b-card>
            </b-collapse>
          </b-row>
        </b-form-group>
        <button
          class="btn btn-outline-info"
          @click="createCommunicationPath"
        >作成</button>
      </b-card>
    </b-collapse>
  </div>
</template>
<script>
import { API, graphqlOperation } from 'aws-amplify'
export default {
  name: 'CommunicationPath',
  props: ['show'],
  data () {
    return {
      communicationPath: {
        no: '',
        design_sender: '',
        design_destination: '',
        physical_connection: '',
        communication_path_list: []
      },
      splitDestination: {
        sa: '',
        sr: '',
        da: '',
        dr: '',
        protocol: ''
      },
      fields: [
        { key: 'sa' },
        { key: 'sr' },
        { key: 'da' },
        { key: 'dr' },
        { key: 'protocol' },
        { key: 'delete' }
      ],
      showAddCommunicationPath: false,
      protocols: ['ITO', 'A', 'MA', 'ITI']
    }
  },
  methods: {
    deleteCommunicationPath (args) {
      this.communicationPath.communication_path_list.splice(args.index, 1)
    },
    addCommunicationPath () {
      this.communicationPath.communication_path_list.push(this.splitDestination)
      this.splitDestination = {
        sa: '',
        sr: '',
        da: '',
        dr: '',
        protocol: ''
      }
    },
    async createCommunicationPath () {
      try {
        const mutationString = `
          mutation createCommunicationPathMaster {
            createCommunicationPathMaster(
              input: {
                no: ${this.communicationPath.no}
                design_sender: "${this.communicationPath.design_sender.split('\t').join('').split(' ').join('')}"
                design_destination: "${this.communicationPath.design_destination.split('\t').join('').split(' ').join('')}"
                physical_connection: ${this.communicationPath.physical_connection}
                communication_path_list: [${this.formatCommunicationPath()}]
              }
            ){
              no
              design_sender
              design_destination
              physical_connection
              communication_path_list {
                sa
                sr
                da
                dr
                protocol
              }
            }
          }`
        this.$log.debug(mutationString)
        const result = await API.graphql(graphqlOperation(mutationString))
        this.$log.debug(result)
        this.$emit('updateList')
        this.communicationPath = {
          no: '',
          design_sender: '',
          design_destination: '',
          physical_connection: '',
          communication_path_list: []
        }
        this.makeToast('成功', '登録に成功しました', 'info')
      } catch (e) {
        this.$log.debug('======= delete communicationPath error ========', e)
        this.makeToast('成功', '登録に失敗しました', 'danger')
      }
    },
    formatCommunicationPath () {
      const eachComPath = this.communicationPath.communication_path_list.reduce(function (acc, cur) {
        let eachStr = '{\n'
        if (cur.sa !== '') {
          eachStr += `sa: "${cur.sa.split('\t').join('').split(' ').join('')}"\n`
        }
        if (cur.sr !== '') {
          eachStr += `sr: "${cur.sr.split('\t').join('').split(' ').join('')}"\n`
        }
        if (cur.da !== '') {
          eachStr += `da: "${cur.da.split('\t').join('').split(' ').join('')}"\n`
        }
        if (cur.dr !== '') {
          eachStr += `dr: "${cur.dr.split('\t').join('').split(' ').join('')}"\n`
        }
        if (cur.protocol !== '') {
          eachStr += `protocol: ${cur.protocol}\n`
        }
        eachStr += '}\n'
        acc += eachStr
        return acc
      }, '')
      return eachComPath
    }
  }
}
</script>
